export default __webpack_public_path__ + "static/media/menu_photo_3.37d18772.png";